define('shared/initializer/form/adapters/mixins/EmailRegistrationValidatable',[],function  () {
    'use strict';

    function Ctor() {
        var me = this;
        
        for( var key in me.items ) {
            if ( !me.items.hasOwnProperty(key) ) {
                continue;
            }

            if ( key == 'email' ) {
                // make sure to validate against registration
                me.items[key].registered = false;
            }
        }
    }

    return Ctor;
});
